export default "__VITE_ASSET__45e77cb5__"